<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { mapActions } from "vuex/dist/vuex.cjs.js";
import Swal from "sweetalert2";

export default {
    page: {
        title: "User Create",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: {
        Layout,
        PageHeader,
    },
    data() {
        return {
            title: "User Create",
            totalWingband: 0,
            chapters: [],
            user: {
                title: "",
                username: "",
                password: "",
                confirm_password: "",
                contact_number: "",
                chapter_ids: [],
            },
            showPassword:false,
            showConfirmPassword:false,
        };
    },
    created() {
        const total = this.$route.query.totalWingband;
        this.totalWingband = total ? parseInt(total, 10) : 0;
    },
    methods: {
        ...mapActions("user", {
            createUser: "create",
        }),
		toggleShow() {
			this.showPassword = !this.showPassword;
		},
		toggleShowConfirm() {
			this.showConfirmPassword = !this.showConfirmPassword;
		},
        async createAdmin() {
            var pl = {
                role: this.user.title,
                username: this.user.username,
                password: this.user.password,
                confirm_password: this.user.confirm_password,
                contact_number: this.user.contact_number,
            }

            if ((this.user.title == 2 || this.user.title == 3) && this.user.chapter_ids.length) {
                pl.chapter_ids = this.user.chapter_ids;
            }

            const confirmed = await Swal.fire({
                title: "Are you sure?",
                text: "You want to create this User?",
                type: "warning",
                showCancelButton: true,
                padding: "2em",
                icon: "warning",
            }).then((result) => {
                return result.isConfirmed;
            });

            if (confirmed) {
                const res = await this.createUser(pl);
                console.log(res.status)
                console.log(res)
                if (res.status == 201) {
                    Swal.fire({
                        icon: "success",
                        title: "You successfully created a new user",
                        text: res.message,
                    });
                    this.goBack();
                } else {
                    var error = res.message;
                    Swal.fire("Failed!", error, "");
                }
            }
        },
        async populateChapters() {
            const res = await this.$store.dispatch("chapter/getAll", { limit: 200 });
            this.chapters = (res?.data?.data && Array.isArray(res.data.data))
                ? res.data.data
                : (Array.isArray(res?.data) ? res.data : []);
        },
        toggleChapter(id) {
            const idx = this.user.chapter_ids.indexOf(id);
            if (idx === -1) {
                this.user.chapter_ids.push(id);
            } else {
                this.user.chapter_ids.splice(idx, 1);
            }
        },
        selectAllChapters() {
            this.user.chapter_ids = this.chapters.map(c => c.id);
        },
        deselectAllChapters() {
            this.user.chapter_ids = [];
        },
        goBack() {
            this.$router.push({ path: "/user" })
        },
    },
    mounted() {
        this.populateChapters();
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card mb-2 p-2">
                    <div class="card-body p-2">
                        <div class="grid-2">
                            <h4 class="mb-4 fw-bolder">Create User</h4>
                            <div class="d-flex justify-content-end align-items-start">
                                <button class="btn btn-danger" @click="goBack()">Back</button>
                            </div>
                        </div>
                        <div class="col-md-12 d-flex">
                            <div class="col-10">
                                <div class="grid-2">
                                    <div class="disflex custom-border p-1">
                                        <label class="filter-label">Username</label>
                                        <input class="form-control" type="text" placeholder="Enter username..."
                                            v-model="this.user.username">
                                    </div>
                                    <div class="disflex custom-border p-1">
                                        <label class="filter-label">Title</label>
                                        <select class="form-control" v-model="this.user.title">
                                            <option value=""  selected disabled>-- Select Title --</option>
                                            <option value="1">Admin</option>
                                            <option value="2">Viewer</option>
                                            <option value="3">Encoder</option>
                                        </select>
                                    </div>
                                    <div class="disflex custom-border p-1 position-relative">
                                        <label class="filter-label">Password</label>
                                        <input class="form-control" :type="showPassword ? 'text':'password'" placeholder="Enter password..."
                                            v-model="this.user.password">
										<i @click="toggleShow" class="eye-btn">
											<span class="icon is-small is-right">
												<i class="fas"
													:class="{ 'fa-eye-slash': showPassword, 'fa-eye': !showPassword }"></i>
											</span>
										</i>
                                    </div>
                                    <div class="disflex custom-border p-1">
                                        <label class="filter-label">Contact Number</label>
                                        <input class="form-control" type="text" placeholder="Enter contact number..."
                                            v-model="this.user.contact_number">
                                    </div>
                                    <div class="disflex custom-border p-1  position-relative">
                                        <label class="filter-label">Confirm Password</label>
                                        <input class="form-control" :type="showConfirmPassword ? 'text':'password'"
                                            placeholder="Enter confirm password..."
                                            v-model="this.user.confirm_password">
										<i @click="toggleShowConfirm" class="eye-btn">
											<span class="icon is-small is-right">
												<i class="fas"
													:class="{ 'fa-eye-slash': showConfirmPassword, 'fa-eye': !showConfirmPassword }"></i>
											</span>
										</i>
                                    </div>
                                    <div class="disflex custom-border p-1" v-if="this.user.title == 2 || this.user.title == 3">
                                        <label class="filter-label">Chapter</label>
                                        <div class="d-flex flex-column w-100 gap-2">
                                            <div v-if="user.chapter_ids.length > 0" class="d-flex flex-wrap gap-1">
                                                <span
                                                    v-for="id in user.chapter_ids"
                                                    :key="id"
                                                    class="badge bg-primary d-flex align-items-center gap-1"
                                                >
                                                    {{ chapters.find(c => c.id === id)?.chapter || id }}
                                                    <i class="bx bx-x" style="cursor:pointer; font-size:14px;" @click="toggleChapter(id)"></i>
                                                </span>
                                            </div>
                                            <div class="chapter-list-box">
                                                <div
                                                    class="chapter-list-item"
                                                    @click="user.chapter_ids.length === chapters.length && chapters.length > 0 ? deselectAllChapters() : selectAllChapters()"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        :checked="user.chapter_ids.length === chapters.length && chapters.length > 0"
                                                        @click.stop="user.chapter_ids.length === chapters.length && chapters.length > 0 ? deselectAllChapters() : selectAllChapters()"
                                                    />
                                                    <span class="ms-2 fw-semibold">Select All</span>
                                                </div>
                                                <hr class="my-1">
                                                <div
                                                    v-for="c in chapters"
                                                    :key="c.id"
                                                    class="chapter-list-item"
                                                    @click="toggleChapter(c.id)"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        :checked="user.chapter_ids.includes(c.id)"
                                                        @click.stop="toggleChapter(c.id)"
                                                    />
                                                    <span class="ms-2">{{ c.chapter }}</span>
                                                </div>
                                                <div v-if="chapters.length === 0" class="chapter-list-item text-muted">
                                                    No chapters available
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-2">
                                <div class="d-flex justify-content-center align-items-center h-100 custom-border">
                                    <button class="btn btn-success py-4 px-5" @click="createAdmin">Create</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
<style scoped>
th,
td {
    width: 75px !important;
    text-align: start;
}

.table> :not(caption)>*>* {
    text-align: center;
    padding: .5rem .1rem .5rem .1rem !important;
}

th {
    text-transform: uppercase;
}
.eye-width {
	border-radius: 0px !important;
}
.eye-btn {
	background-color: transparent;
	border: none;
	color: rgb(109, 109, 109) !important;
	border-radius: 0px !important;
	position: absolute;
	cursor: pointer;
	right: 10px;
}

.chapter-list-box {
    width: 100%;
    height: 200px;
    overflow-y: auto;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background: #fff;
}
.chapter-list-item {
    display: flex;
    align-items: center;
    padding: 8px 16px;
    cursor: pointer;
    font-size: 14px;
    transition: background 0.15s;
    user-select: none;
}
.chapter-list-item:hover {
    background-color: #f1f3ff;
}
.chapter-list-item input[type="checkbox"] {
    cursor: pointer;
    width: 16px;
    height: 16px;
    flex-shrink: 0;
}
</style>